<template>
    <div class="row">
        <div class="card">
            <div class="card-header">
                <h2>Dados do Contato</h2>
            </div>
            <div>
                <div class="form">
                    <validation-observer ref="forms" v-slot="{handleSubmit}">
                        <form class="form-group">
                            <div class="grid-3">
                                <validation-provider name="CPF" vid="cpf" rules="required" v-slot="{errors}" tag="div" class="input-std form-text">
                                    <label>CPF</label>
                                    <input type="text" placeholder="CPF do participante" v-model="form.cpf" v-mask="'###.###.###-##'" class="input-size" disabled />
                                    <p class="errors">{{errors[0]}}</p>
                                </validation-provider>

                                <validation-provider name="Nome" vid="nome" rules="required" v-slot="{errors}" tag="div" class="input-std form-text">
                                    <label>Nome Completo</label>
                                    <input type="text" placeholder="Nome do participante" v-model="form.nome_completo" disabled />
                                    <p class="errors">{{errors[0]}}</p>
                                </validation-provider>

                                <validation-provider name="Cargo" vid="cargo" rules="required" v-slot="{errors}" tag="div" class="input-std form-text">
                                    <label>Cargo</label>
                                    <input type="text" placeholder="Cargo do participante" v-model="form.cargo" disabled />
                                    <p class="errors">{{errors[0]}}</p>
                                </validation-provider>
                            </div>

                            <div class="grid-4">
                                <validation-provider name="Email" vid="email" rules="required|email" v-slot="{errors}" tag="div" class="input-std form-text">
                                    <label>Email do Representante</label>
                                    <input type="text" placeholder="Email do participante" v-model="form.email" disabled />
                                    <p class="errors">{{errors[0]}}</p>
                                </validation-provider>

                                <validation-provider name="Telefone Fixo" vid="celular" rules="required" v-slot="{errors}" tag="div" class="input-std form-text">
                                    <label>Telefone fixo</label>
                                    <input type="text" v-model="form.telefone" placeholder="Telefone fixo" v-mask="'(##) ####-####'" disabled />
                                    <p class="errors">{{errors[0]}}</p>
                                </validation-provider>

                                <validation-provider name="Celular" vid="celular" rules="required" v-slot="{errors}" tag="div" class="input-std form-text">
                                    <label>Celular</label>
                                    <input type="text" placeholder="Celular" v-model="form.celular" v-mask="'(##) #####-####'" disabled />
                                    <p class="errors">{{errors[0]}}</p>
                                </validation-provider>

                                <validation-provider name="Whatsapp" vid="whatsapp" rules="required" v-slot="{errors}" tag="div" class="input-std form-text">
                                    <label>Whatsapp</label>
                                    <input type="text" placeholder="Whatsapp" v-model="form.whatsapp" v-mask="'(##) #####-####'" disabled />
                                    <p class="errors">{{errors[0]}}</p>
                                </validation-provider>
                            </div>

                            <h3 class="card-header">Endereço do Contato</h3>

                            <div class="grid-4">
                                <validation-provider name="Cep" vid="cep" rules="required" v-slot="{errors}" tag="div" class="input-std form-text">
                                    <label>CEP</label>
                                    <input type="text" placeholder="CEP do participante" v-model="form.cep" maxlength="9" disabled />
                                    <p class="errors">{{errors[0]}}</p>
                                </validation-provider>

                                <validation-provider name="Endereço" vid="nome" rules="required" v-slot="{errors}" tag="div" class="input-std form-text">
                                    <label>Endereço</label>
                                    <input type="text" placeholder="Endereço do participante" v-model="form.endereco" disabled />
                                    <p class="errors">{{errors[0]}}</p>
                                </validation-provider>

                                <validation-provider name="Número" vid="numero" rules="required" v-slot="{errors}" tag="div" class="input-std form-text">
                                    <label>Numero</label>
                                    <input type="text" placeholder="Número" v-model="form.nro" disabled />
                                    <p class="errors">{{errors[0]}}</p>
                                </validation-provider>

                                <validation-provider name="Bairro" vid="bairro" rules="required" v-slot="{errors}" tag="div" class="input-std form-text">
                                    <label>Bairro</label>
                                    <input type="text" placeholder="Bairro do participante" v-model="form.bairro" disabled />
                                    <p class="errors">{{errors[0]}}</p>
                                </validation-provider>
                            </div>

                            <div class="grid-2">
                                <validation-provider name="Cidade" vid="cidade" rules="required" v-slot="{errors}" tag="div" class="input-std form-text">
                                    <label>Cidade</label>
                                    <input type="text" placeholder="Cidade do participante" v-model="form.cidade" disabled />
                                    <p class="errors">{{errors[0]}}</p>
                                </validation-provider>

                                <validation-provider name="Estado" vid="estado" rules="required" v-slot="{errors}" tag="div" class="input-std form-text">
                                    <label>UF</label>
                                    <input type="text" placeholder="UF" v-model="form.estado" disabled />
                                    <p class="errors">{{errors[0]}}</p>
                                </validation-provider>
                            </div>

                            <div class="flex justify-end">
                                <router-link to="/sistema/eventos/lista-contatos" class="btn btn-primary">
                                    Voltar
                                </router-link>
                            </div>
                        </form>
                    </validation-observer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mask } from "vue-the-mask"
    export default {
        name: 'visualizar-contato',

        directives: { mask },

        created() {
            this.getContato()
        },

        data() {
            return {
                form: {
                    id: null,
                    cpf: '',
                    nome_completo: '',
                    cep: '',
                    endereco: '',
                    nro: '',
                    bairro: '',
                    cidade: '',
                    estado: '',
                    cargo: '',
                    email: '',
                    telefone: '',
                    celular: '',
                    whatsapp: ''
                },
            }
        },

        methods: {
            async getContato() {
                this.axios('inscritos/' + this.$route.params.id).then(response => {
                    this.form = response.data.inscrito
                }).catch(error => {
                    console.error(error)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .form-1{
        @media(min-width: 640px) {
            @apply grid-cols-3;
        }
    }
    .form-2{
        @media(min-width: 640px) {
            @apply grid-cols-2;
        }
        @media(min-width: 1024px) {
            @apply grid-cols-4;
        }
    }
    .form-3{
        @media(min-width: 640px) {
            @apply grid-cols-2;
        }
        @media(min-width: 1024px) {
            @apply grid-cols-4;
        }
    }
    .form-4{
        @media(min-width: 640px) {
            @apply grid-cols-2;
        }
    }
</style>
